import { Divider } from '@mui/material';

function AppDivider(props) {
    return (
        <Divider {...props} sx={{ borderColor: '#ddd', borderBottomWidth: '1px', opacity: 1 }} />
    );
}
export default AppDivider;
